import { useContext } from "react";
import { CancellationModalContext } from "./CancellationModalProvider";

export const useMaybeCancellationModal = () =>
  useContext(CancellationModalContext);
